export const CURRENT_SYMPTOMS_TEXT_1 = `Have you experienced any of the following symptoms in the past 14 days?`;
export const CURRENT_SYMPTOMS_TEXT_2 = `Please select all that apply.`;
export const CURRENT_SYMPTOMS_TEXT_3 = `When did you first start having symptoms?`;

export enum CovidSymptomsEnums {
  fever = 'Q_Fever',
  cough = 'Q_New_or_Worsening_Cough',
  shortnessOfBreath = 'Q_Shortness_of_Breath_New_or_Worsening',
  fatigueOrBodyAches = 'Q_Body_Aches',
  soreThroat = 'Q_COVID_Screen_Sore_Throat',
  runnyNose = 'Q_COVID_Screen_Runny_Nose',
  lossOfSmell = 'Q_COVID_Screen_Decreased_Smell_or_Taste',
  diarrhea = 'Q_Diarrhea',
  noneOfTheAbove = 'Q_None_of_the_above'
}
export interface CovidSymptomsCheckbox {
  key: number;
  label: string;
  fieldName: CovidSymptomsEnums;
}
export const COVID_SYMPTOMS: CovidSymptomsCheckbox[] = [
  {
    key: 1,
    label: 'Fever',
    fieldName: CovidSymptomsEnums.fever
  },
  {
    key: 2,
    label: 'Cough',
    fieldName: CovidSymptomsEnums.cough
  },
  {
    key: 3,
    label: 'Shortness of breath',
    fieldName: CovidSymptomsEnums.shortnessOfBreath
  },
  {
    key: 4,
    label: 'Fatigue or body aches',
    fieldName: CovidSymptomsEnums.fatigueOrBodyAches
  },
  {
    key: 5,
    label: 'Sore throat',
    fieldName: CovidSymptomsEnums.soreThroat
  },
  {
    key: 6,
    label: 'Runny nose',
    fieldName: CovidSymptomsEnums.runnyNose
  },
  {
    key: 7,
    label: 'Loss of smell',
    fieldName: CovidSymptomsEnums.lossOfSmell
  },
  {
    key: 8,
    label: 'Diarrhea',
    fieldName: CovidSymptomsEnums.diarrhea
  },
  {
    key: 9,
    label: 'None of the above',
    fieldName: CovidSymptomsEnums.noneOfTheAbove
  }
];
